import { isMuted, toggleMute } from '../sound.js';

/** Lautsprecher-Toggle-Button. Spiegelt den persistierten Mute-Status. */
export function makeMuteButton(): HTMLButtonElement {
  const b = document.createElement('button');
  b.type = 'button';
  b.className = 'ghost icon mute-btn';
  const paint = (): void => {
    const m = isMuted();
    b.textContent = m ? '🔇' : '🔊';
    b.title = m ? 'Ton einschalten' : 'Ton ausschalten';
    b.setAttribute('aria-label', b.title);
  };
  paint();
  b.addEventListener('click', () => { toggleMute(); paint(); });
  return b;
}
